<template>
  <div class='lib__form__main' data-cy='contact-component'>
    <ValidationObserver ref='validator' slim>
      <div class='lib__form__main__content'>
        <header class='lib__form__main__header'>
          <h2 class='lib__h2'>
            {{ $t('prosumerDeclaration.relay.title') }}
            <div class='lib__tooltips' @click='titleModalOpen = true'>
              <span>
                <i class='fas fa-info-circle lib__clickable-tooltips'></i>
              </span>
            </div>
          </h2>
        </header>
        <RelayInformationComponent v-model='installationState.relay' />
      </div>
    </ValidationObserver>

    <ModalDialog :closeable="$t('common.close')" :open.sync='titleModalOpen'>
      <h3>{{ $t('prosumerDeclaration.relay.modal.title.title') }}</h3>
      <p v-html="$t('prosumerDeclaration.relay.modal.title.text1')" />
      <p v-html="$t('prosumerDeclaration.relay.modal.title.text2')" />
    </ModalDialog>
  </div>
</template>

<script lang='ts'>
import { Component } from 'vue-property-decorator'
import Step from '@/components/steps/Step'
import { State } from 'vuex-class'
import { InstallationInformation } from '@/models/prosumer-declaration/prosumer-declaration'
import RelayInformationComponent from '@/components/inputs/ProsumerDeclaration/RelayInformationComponent.vue'

@Component({
  name: 'relay-step',
  components: {
    RelayInformationComponent
  }
})
export default class RelayStep extends Step {
  //#region [Data]
  @State('requestId', { namespace: 'prosumerDeclaration' }) public requestId!: string
  @State('installation', { namespace: 'prosumerDeclaration/installation' })
  public installationState!: InstallationInformation

  public titleModalOpen: boolean = false
  //#endregion

  //#region [Method]
  public mounted() {
    this.setIsBack(false)
  }

  public async save(next: boolean, isValid: boolean) {
    if (next && isValid) {
      this.$appInsights.trackEvent('ProsumerDeclaration_StepRelay_Validated', {
        Segment: 'ProsumerDeclaration',
        WebRef: this.requestId
      })
    }
  }

  //#endregion
}
</script>
